var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"index-metric-get\">\n<h4>Get Totals</h4>\n<table class=\"table table-condensed table-hover table-striped\">\n<thead>\n<tr>\n<th></th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>Exists</td>\n<td>{{indexMetricGetCtrl.stats.primaries.get.exists_total | numeral: '0[,][0]'}}</td>\n</tr>\n<tr>\n<td>Missing</td>\n<td>{{indexMetricGetCtrl.stats.primaries.get.missing_total | numeral: '0[,][0]'}}</td>\n</tr>\n<tr>\n<td>Gets</td>\n<td>{{indexMetricGetCtrl.stats.primaries.get.total | numeral: '0[,][0]'}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/index-metric-get/index-metric-get.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/index-metric-get/index-metric-get.template.html
// module id = 876
// module chunks = 0